import React from 'react';
import { Table, Badge } from 'react-bootstrap';
import { motion } from 'framer-motion';

interface PaymentHistoryItem {
  id: string;
  date: string;
  type: string;
  amount: string;
  method: string;
  status: string;
}

interface PaymentHistoryProps {
  paymentHistory: PaymentHistoryItem[];
}

const PaymentHistory: React.FC<PaymentHistoryProps> = ({ paymentHistory }) => {
  const getStatusBadge = (status: string) => {
    switch (status.toLowerCase()) {
      case 'paid':
        return (
          <span
            style={{
              backgroundColor: '#03C01933',
              color: '#03C019',
              fontSize: '14px',
              fontWeight: 'normal',
              padding: '6px 12px',
              borderRadius: '4px',
              border: 'none',
              display: 'inline-block'
            }}
          >
            Success
          </span>
        );
      case 'success':
        return (
          <span
            style={{
              backgroundColor: '#03C01933',
              color: '#03C019',
              fontSize: '14px',
              fontWeight: 'normal',
              padding: '6px 12px',
              borderRadius: '4px',
              border: 'none',
              display: 'inline-block'
            }}
          >
            Success
          </span>
        );
      case 'pending':
        return <Badge bg="warning">Pending</Badge>;
      case 'failed':
        return <Badge bg="danger">Failed</Badge>;
      default:
        return <Badge bg="secondary">{status}</Badge>;
    }
  };

  const tableVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        staggerChildren: 0.1
      }
    }
  };

  const rowVariants = {
    hidden: { opacity: 0, x: -20 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.3 }
    }
  };

  return (
    <motion.div
      className="payment-history"
      variants={tableVariants}
      initial="hidden"
      animate="visible"
    >
     
      {paymentHistory.length === 0 ? (
        <div className="no-payments text-center py-5">
          <i className="bi bi-credit-card" style={{ fontSize: '3rem', color: '#ccc' }}></i>
          <h5 className="mt-3 text-muted">No Payment History</h5>
          <p className="text-muted">Your payment transactions will appear here once you make a purchase.</p>
        </div>
      ) : (
        <div className="table-responsive">
          <Table className="payment-history-table">
            <thead>
              <tr>
                <th style={{ whiteSpace: 'nowrap' }}>Transaction ID</th>
                <th style={{ whiteSpace: 'nowrap' }}>Date</th>
                <th style={{ whiteSpace: 'nowrap' }}>Type</th>
                <th style={{ whiteSpace: 'nowrap' }}>Amount</th>
                <th style={{ whiteSpace: 'nowrap' }}>Payment Method</th>
                <th style={{ whiteSpace: 'nowrap' }}>Status</th>
              </tr>
            </thead>
            <tbody>
              {paymentHistory.map((payment, index) => (
                <motion.tr
                  key={payment.id}
                  variants={rowVariants}
                  className="payment-row"
                >
                  <td className="transaction-id" style={{ whiteSpace: 'nowrap' }}>
                    {payment.id.slice(-5)}
                  </td>
                  <td className="payment-date" style={{ whiteSpace: 'nowrap' }}>
                    {payment.date}
                  </td>
                  <td className="payment-type" style={{ whiteSpace: 'nowrap' }}>
                    <span className="type-label">{payment.type}</span>
                  </td>
                  <td className="payment-amount" style={{ whiteSpace: 'nowrap' }}>
                    <strong>{payment.amount}</strong>
                  </td>
                  <td className="payment-method" style={{ whiteSpace: 'nowrap' }}>
                    <span className="method-text">
                      <i className="bi bi-credit-card me-1"></i>
                      {payment.method}
                    </span>
                  </td>
                  <td className="payment-status" style={{ whiteSpace: 'nowrap' }}>
                    {getStatusBadge(payment.status)}
                  </td>
                </motion.tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}
    </motion.div>
  );
};

export default PaymentHistory;